<template>
	<div>
		<div class="flex center text-center mb-1" v-if="loader">
			<i class="fas fa-cog fa-spin fa-2x"></i>
			Loading....
		</div>

		<form :action="endPoint" class="list-filter flex box" method="get" ref="filterForm" v-if="!loader">
			<div class="two form-group">
				<label for="limit"><i class="fas fa-fw fa-list-ul"></i> Show</label>
				<select @change="onFormChange" id="limit" name="limit" v-model="selectedLimit">
					<option value="null">25</option>
					<option value="50">50</option>
					<option value="100">100</option>
				</select>
			</div>

			<div class="ten form-group">
				<label for="filter"><i class="fas fa-fw fa-filter"></i> Filter</label>
				<div class="input-group">
					<input @change="checkReset" @keyup="onFilterChange" class="input-small" id="filter" name="filter"
						   placeholder="Filter in Name or Email" type="text" v-model="urlParams.filter">
					<button :disabled="!this.filterEnabled" @click="clearForm" class="btn btn-primary">Filter</button>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
	export default {
		props: {
			dataEndpoint: {
				type: String
			},
			dataUrlParams: {
				type: Object,
				required: false
			}
		},

		data() {
			return {
				endPoint: this.dataEndpoint,
				urlParams: this.dataUrlParams || {},
				loader: false,
				filterEnabled: this.dataUrlParams.filter && this.dataUrlParams.filter.length > 0,
				selectedLimit: this.dataUrlParams.limit ? this.dataUrlParams.limit : null,
			}
		},

		methods: {
			clearForm: function () {
				$('input, select').each(function (_, inp) {
					if ($(inp).val() === '' || $(inp).val() === 'null' || $(inp).val() === null)
						inp.disabled = true;
				});
			},
			checkReset: function () {
				if (this.urlParams.filter.length === 0) {
					this.onFormChange();
				}
			},
			onFormChange: function () {
				this.loader = true;
				this.clearForm();
				this.$refs.filterForm.submit();
			},
			onFilterChange: function () {
				this.filterEnabled = this.urlParams.filter && this.urlParams.filter.length > 0;
			},
		}
	}
</script>
